.bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 48px;
  height: 68px;
  background: rgba(5, 8, 24, 0.7);
  backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.brand {
  font-family: "Cormorant Garamond", serif;
  font-size: 24px;
  cursor: pointer;
}

.actions {
  display: flex;
  gap: 24px;
  align-items: center;
}

.link {
  font-size: 14px;
  cursor: pointer;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
}

.menuButton {
  display: none;
  min-width: 44px;
  min-height: 44px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  color: inherit;
  font-size: 20px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}

.mobilePanel {
  display: none;
}

.mobileBackdrop {
  display: none;
}

@media (max-width: 900px) {
  .bar {
    padding: 0 16px;
  }

  .actions {
    display: none;
  }

  .menuButton {
    display: inline-flex;
  }

  .mobileBackdropOpen {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 18;
    border: none;
    background: rgba(0, 0, 0, 0.55);
    cursor: pointer;
  }

  .mobilePanelOpen {
    display: flex;
    flex-direction: column;
    gap: 4px;
    position: fixed;
    top: 68px;
    left: 0;
    right: 0;
    z-index: 19;
    padding: 12px 16px 20px;
    background: rgba(8, 12, 32, 0.98);
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(20px);
  }

  .mobileLink {
    font-size: 15px;
    cursor: pointer;
    min-height: 44px;
    display: flex;
    align-items: center;
    padding: 0 8px;
    border-radius: 8px;
  }

  .mobileLink:hover {
    background: rgba(255, 255, 255, 0.04);
  }

  .mobileActions {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 8px;
  }

  .mobileLocale {
    display: flex;
    justify-content: flex-start;
    padding: 8px 0 4px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    margin-top: 4px;
    width: 100%;
    box-sizing: border-box;
  }
}
